<template>
	<div class="goodInfo">
		<van-nav-bar :title="title" fixed left-arrow @click-left="onClickLeft">
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" />
			</template>
			<template #right v-if="goodInfo">
				<van-icon name="share" @click="shareStoreGood"/>
			</template>
		</van-nav-bar>

		<div class="collapse" v-if="!goodInfo&&goodInfoloaded">
			<div class="empty">
				<span class="msg">商品找不到了！</span>
			</div>
		</div>
		<div class="collapse" v-else-if="goodInfoloaded" :style="{'padding-bottom':'50px'}">
			<div class="info-top">
				<img class="top_img" :src="attach_url+goodInfo.g_img"/>
				<div class="van-card__content">
					<div>
						<div class="van-card__title">{{goodInfo.g_name}}</div>
					</div>
					<div class="van-card__bottom" :style="{'text-align':'right'}">
						<div class="van-card__price color_red">
							<div>
								<span class="van-card__price-currency">¥</span>
								<span class="van-card__price-integer">{{Math.floor(goodInfo.g_price)}}</span>.<span class="van-card__price-decimal">{{(goodInfo.g_price-Math.floor(goodInfo.g_price))*100}}</span>
							</div>
						</div>
						<div class="van-card__origin-price" v-if="goodInfo.g_price_origin">¥ {{goodInfo.g_price_origin}}</div>
					</div>
				</div>
			</div>

			<van-notice-bar left-icon="info-o" v-if="pro_note">{{pro_note}}</van-notice-bar>

			<div class="van-card__content" v-if="goodInfo.activities.length>0">
				<div>
					<div class="van-card__title"><div class="line skin_bgcolor"></div>优惠</div>
					<van-tag plain type="danger" v-for="(act,aind) in goodInfo.activities" :key="'act-'+goodInfo.g_id+aind">
						{{act+(parseInt(goodInfo.singles[aind])==1?'「叠」':'')}}
					</van-tag>
				</div>
			</div>

			<div class="van-card__content">
				<div>
					<div class="van-card__title"><div class="line skin_bgcolor"></div>详情</div>
				</div>

				<div class="note_content" v-html="goodInfo.g_note"></div>

				<img :src="attach_url+goodInfo.g_note_img" v-if="goodInfo.g_note_img"/>

				<van-cell-group title="请选择" v-if="shoppingGoodSku.length > 0">
					<!--van-cell
						:title="sku.sku_name+'：'"
						title-class="van-cell-title"
						v-for="(sku,ind) in shoppingGoodSku"
						:key="'sku_'+ind"
						>
						<template #default>
							<span 
								@click="chkGoodSku(ind, sind, sku.sku_switch)" 
								:class="{'van-sku-row__item': true}" 
								v-for="(skuo, sind) in sku.goodSkus" 
								:key="'isku_'+sind" 
								:style="{'margin':'3px 5px'}"
								:ref="'ref_sku_'+ind+'_'+sind"
							>
								<div class="van-sku-row__item-name">{{skuo}}</div>
							</span>
						</template>
					</van-cell-->
					<div class="van-sku-group-container van-sku-group-container--hide-soldout">

						<div class="van-sku-row"
						v-for="(sku,ind) in shoppingGoodSku"
						:key="'sku_'+ind">
							<div class="van-sku-row__title">{{sku.sku_name}}</div>
							
							<span 
								@click="chkGoodSku(ind, sind, sku.sku_switch)" 
								:class="{'van-sku-row__item': true}" 
								v-for="(skuo, sind) in sku.goodSkus" 
								:key="'isku_'+sind" 
								:style="{'margin':'3px 5px'}"
								:ref="'ref_sku_'+ind+'_'+sind"
							>
								<div class="van-sku-row__item-name">{{skuo}}</div>
							</span>
						</div>
					</div>
				</van-cell-group>
			</div>
			<van-goods-action>
				<van-goods-action-icon icon="chat-o" text="客服" class="skin_color" icon-class="skin_color" @click="toChat" v-if="shoppingCart.store&&shoppingCart.store.u_id!=u_id"/>  
				<van-goods-action-icon icon="cart-o" text="购物车"  :dot="shoppingDot" @click="goShoppingCart" v-if="shoppingCart.store&&shoppingCart.store.u_id!=u_id"/>
				<van-goods-action-icon icon="shop-o" text="店铺" @click="onClickLeft" />
				<van-goods-action-icon  :icon="goodInfo.favorites?'star':'star-o'" :text="goodInfo.favorites?'已收藏':'收藏'" :class="goodInfo.favorites?'color_red':''" :icon-class="goodInfo.favorites?'color_red':''" @click="resetFavotites"/>
				<van-goods-action-button type="warning" text="加入购物车" @click="putShoppingCart(false)"/>
				<van-goods-action-button type="danger" text="立即购买"  @click="goShopping"/>
			</van-goods-action>
		</div>


		<share :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="0" v-show="showShareSheet" v-if="initShareSheet"/>

	</div>
</template>

<script>
import { goodUnit,chkWeiXin } from "@/utils/common.js";
import { GoodsAction, GoodsActionIcon, GoodsActionButton} from 'vant';
import Share from "@/components/Commom/Share";

export default {
	name: "goodInfo",
	components: {
		'van-goods-action':GoodsAction,
		'van-goods-action-icon':GoodsActionIcon,
		'van-goods-action-button':GoodsActionButton,
		"share":Share
	},
	data() {
		return {
			title: "商品详情",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url: this.Conf.serverPre,
			cur_s_id:-1,
			cur_g_id:-1,
			goodInfoloaded:false,
			goodInfo:null,
			resetFavotitesFlag:false,
			shoppingCart:{},
			shoppingDot:false,
			store_u_id:-1,
			goodUnitObj:{},
			pro_note:"",
			shoppingGoodSku:[],
			chkGoodSkued:{},

			showShareSheet:false,
			shareQRCodeUrl:'',
			shareConfig:{},
			initShareSheet:false
		};
	},
	methods: {
		// 返回
		onClickLeft() {
			this.$router.push({
				path: "/Shopping/"+this.cur_s_id
			});
		},
		resetFavotites(){
			if(this.u_id && this.token){
				if(this.resetFavotitesFlag){
					this.$toast.fail("正在处理，请稍候！");
				}
				this.resetFavotitesFlag = true;
				var params = {
					f_type: 2,
					u_id: this.u_id,
					token: this.token,
					f_id: this.cur_g_id,
					o_type: this.goodInfo.favorites?'del':'add'
				};
				var url = this.Conf.serverUrl + "User/favorites" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.$toast.success(response.data.msg);
					this.resetFavotitesFlag = true;
					this.goodInfo.favorites = this.goodInfo.favorites?0:1;
				})
				.catch(error => {
					this.resetFavotitesFlag = true;
				});
			}else{
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后才能收藏！",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再逛逛'
				})
				.then(() => {
					this.$router.push({
						path: "/Login"
					});
				})
				.catch(error => {});
			}
			return false;
		},
		goShopping(){
			if(this.shoppingCart.store&&this.shoppingCart.store.u_id==this.u_id){
				this.$toast.fail("请移至店铺管理中操作！");
				return false
			}
			this.putShoppingCart(true);
			this.goShoppingCart();
		},
		goShoppingCart(){
			this.$router.push({
				path: "/Cart"
			});
		},
		putShoppingCart(auto){
			if(this.shoppingCart.store&&this.shoppingCart.store.u_id==this.u_id){
				this.$toast.fail("请移至店铺管理中操作！");
				return false
			}
			let skuSelect = this.chkGoodSkuSelected();
			if(this.shoppingGoodSku.length==0 || skuSelect){
				this.goodInfo.g_sku_str = skuSelect;
				let incart = false;
				for(var i in this.shoppingCart.cart){
					if(this.goodInfo.g_id==this.shoppingCart.cart[i].g_id){
						incart = true;
						break;
					}
				}
				if(!incart){
					this.shoppingCart.cart.push(this.goodInfo);
					if(!auto){
						this.$toast.success("已加入购物车！");
					}
				}else if(!auto){
					this.$toast.fail("您的购物车已有此商品！");
				}
				this.shoppingDot = true;
			}
		},
		toChat(){
			if(this.u_id && this.token){
				this.$router.push({
					name: "Chatroom",
					query: {
						friend_id: this.shoppingCart.store.u_id,
						friend_name: this.shoppingCart.store.s_name,
						bottomstatus:1,
					},
				});
			}else{
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后即可咨询？",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再逛逛'
				})
				.then(() => {
					this.$router.push({
						path: "/Login"
					});
				})
				.catch(error => {});
			}
			return false;
		},
		chkGoodSku(ind, sind, cswitch){
			let key = 'sku_'+ind+'_'+sind;
			if(this.chkGoodSkued[key]){
				//this.chkGoodSkued[key] = false;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item';
				this.$delete(this.chkGoodSkued, key);
			}else{
				this.chkGoodSkued[key] = true;
				this.$refs['ref_'+key][0].className = 'van-sku-row__item van-sku-row__item--active';
				if(cswitch!='true'){
					for(var k in this.chkGoodSkued){
						if(k.indexOf('sku_'+ind+'_') > -1 && k!=key){
							//this.chkGoodSkued[k] = false;
							this.$refs['ref_'+k][0].className = 'van-sku-row__item';
							this.$delete(this.chkGoodSkued, k);
						}
					}
				}
			}
		},
		chkGoodSkuSelected(){
			let seledSkuStr = "";
			let seledSku = false;
			let seledSkuVal = {};
			for(var k in this.chkGoodSkued){
				if(this.chkGoodSkued[k]){
					seledSku = true;
					var kk = k.split("_");
					if(seledSkuVal[kk[1]]){
						seledSkuVal[kk[1]].push(kk[2]);
					}else{
						seledSkuVal[kk[1]] = [kk[2]];
					}
				}
			}
			if(this.shoppingGoodSku.length>0 && !seledSku){
				this.$toast.fail("请先选择商品规格！");
				return false;
			}

			for(var k in seledSkuVal){
				seledSkuStr += this.shoppingGoodSku[k].sku_name;
				seledSkuStr += '（';
				for(var ki in seledSkuVal[k]){
					seledSkuStr += this.shoppingGoodSku[k].goodSkus[seledSkuVal[ki]]+'，';
				}
				seledSkuStr += '）';
			}
			return seledSkuStr;
		},
		shareStoreGood(){
			this.showShareSheet = true;
		},
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		}
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		this.cur_s_id = this.$route.params.s_id;
		this.cur_g_id = this.$route.params.g_id;
		var params = {
			u_id: this.u_id,
			token: this.token,
			s_id: this.cur_s_id,
			g_id: this.cur_g_id
	    };

		let isWxEnv = chkWeiXin();
		this.shareQRCodeUrl = this.Conf.clientOrigin+'/m/#/Product/'+this.cur_s_id+'/'+this.cur_g_id;
		if(isWxEnv){
			this.shareQRCodeUrl = location.href;
		}
	    var url = this.Conf.serverUrl + "Store/good" + "?num="+Math.random();
	    this.$axios
		.post(url, this.$qs.stringify(params))
		.then(response => {
			if(response.data.good){
				this.goodInfoloaded = true;
				this.goodInfo = response.data.good;
				if(this.goodInfo.g_day_limit>0){
					this.pro_note += "每天限购：" + this.goodInfo.g_day_limit + " " + this.goodUnitObj[this.goodInfo.g_unit]
					if(this.goodInfo.buyed){
						this.pro_note += "；已售：" + this.goodInfo.buyed + " " + this.goodUnitObj[this.goodInfo.g_unit];
					}
					if(this.goodInfo.buying){
						this.pro_note += "；付款中：" + this.goodInfo.buying + " " + this.goodUnitObj[this.goodInfo.g_unit];
					}
				}
				this.shoppingGoodSku = this.goodInfo.g_sku?JSON.parse(this.goodInfo.g_sku):[];

				this.shareConfig = {
					title: this.goodInfo.g_name, // 分享标题
					desc: this.goodInfo.g_note, // 分享描述
					link: this.shareQRCodeUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: this.attach_url+this.goodInfo.g_img, // 分享图标
				}
				this.initShareSheet = true;
			}
		})
		.catch(error => {});

		let storageShoppingCart = localStorage.getItem("myShoppingCart")?JSON.parse(localStorage.getItem("myShoppingCart")):{};
		this.shoppingDot = Object.keys(storageShoppingCart).length>0;
		if(!storageShoppingCart['store_'+this.cur_s_id]){
			storageShoppingCart['store_'+this.cur_s_id] = {store:{},cart:[],express:0}
		}
		this.shoppingCart = storageShoppingCart['store_'+this.cur_s_id];

		var params = {
			s_id: this.cur_s_id,
			u_id: this.u_id
	    };
	    var url = this.Conf.serverUrl + "Store/info" + "?num="+Math.random();
	    this.$axios
		.post(url, this.$qs.stringify(params))
		.then(response => {
			if(response.data.store){
				let storeinfo = response.data.store;
				this.shoppingCart.store = {s_name:storeinfo.s_name,s_img:storeinfo.s_img,u_id:storeinfo.u_id};
				this.shoppingCart.express = storeinfo.express;
				this.store_u_id = storeinfo.u_id;
			}else{
				this.goodInfo = null;
			}
		})
		.catch(error => {});
	},
	beforeDestroy: function () {
		if(this.shoppingCart.cart.length > 0){
			let storageShoppingCart = localStorage.getItem("myShoppingCart")?JSON.parse(localStorage.getItem("myShoppingCart")):{}
			storageShoppingCart['store_'+this.cur_s_id] = this.shoppingCart;
			localStorage.setItem("myShoppingCart", JSON.stringify(storageShoppingCart));
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/components/Store/Product.vue